import React from "react";
interface Props {
  data: any;
}
function GeneralInfo({ data }: Props) {
  return (
    <div className="ubbe-card h-100">
      <div className="ubbe-card-header">
        <h5 className="ps-3 mb-0 GlobalBoxHead">General Info</h5>
      </div>
      <div className="card-body pt-2 p-4 h-auto">
        <div className="row">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-7">
                <span className="global-text-16">Created Date</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.barcode ? data?.barcode : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">ID (Barcode)</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.created_By ? data?.created_By : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Location</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.freight_type ? data?.freight_type : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Name</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.customer_name ? data?.customer_name : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Type</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.origin_location_code
                  ? data?.origin_location_code
                  : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Dims</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.destination_location_code
                  ? data?.destination_location_code
                  : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Weight</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.priority ? data?.priority : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Tare Weight</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.consigned_to_name ? data?.consigned_to_name : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Weight Capacity</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.consigned_to_name ? data?.consigned_to_name : "N/A"}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-7">
                <span className="global-text-16">Cubage</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.created_By ? data?.created_By : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Cubage Capacity</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.created_By ? data?.created_By : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Manifest No.</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.created_By ? data?.created_By : "N/A"}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-7">
                <span className="global-text-16">Consolidation No.</span>
              </div>
              <div className="col-md-5 boldglobaltext text-break">
                {data?.created_By ? data?.created_By : "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralInfo;
